<template>
  <b-container fluid class="p-0">
    <meu-menu> </meu-menu>

    <b-col
      class="mt-2"
      md="4"
      offset-md="4"
      v-if="
        this.user.id !== null &&
        this.user.id > 0 &&
        this.token !== null &&
        this.token.length > 0
      "
    >
      <b-card
        :header="header"
        header-text-variant="white"
        header-tag="header"
        header-bg-variant="primary"
        style="border-radius: 5px; border: 1px solid #d4d4d4; height: 103%"
      >
        <b-card-text>
          <b-row>
            <b-col cols="12">
              <b-alert show :variant="dica">
                <span class="text-center">
                  Informe os dados clique em confirmar para trocar a senha!!
                </span>
              </b-alert>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="m-1" cols="12">
              <b-form-group label="Senha">
                <b-icon
                  :icon="passwordIcon"
                  style="color: #7952b3"
                  @click="hidePassword = !hidePassword"
                ></b-icon>
                <b-form-input
                  v-model="senha"
                  :type="passwordType"
                  @keydown.enter.stop.prevent
                  required
                ></b-form-input>
                <small class="message">
                  o Tamanho minimo da senha é de 6 caracteres(numeros e/ou
                  letras)
                </small>
              </b-form-group>
            </b-col>
            <b-col class="m-1" cols="12">
              <b-form-group label="Confirmar a senha">
                <b-icon
                  :icon="passwordIcon_conf"
                  style="color: #7952b3"
                  @click="hidePassword_conf = !hidePassword_conf"
                ></b-icon>
                <b-form-input
                  v-model="senha_confirmar"
                  :type="passwordType_conf"
                  @keydown.enter.stop.prevent
                  required
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
        </b-card-text>

        <template v-slot:header>
          <b-row>
            <b-col lg="2" sm="12">
              <b-icon
                icon="arrow-repeat"
                font-scale="3"
                style="color: #fff"
              ></b-icon>
            </b-col>
            <b-col lg="10" sm="12">
              <h6 class="mt-3">
                <b>{{ user.nome }}</b>
              </h6>
            </b-col>
          </b-row>
        </template>

        <template v-slot:footer>
          <b-row>
            <b-col lg="12" sm="12">
              <router-link :to="{ name: 'curriculo_main' }">
                <b-btn class="m-1 float-md-right" variant="danger">
                  <b-icon-x-square></b-icon-x-square> Cancelar
                </b-btn>
              </router-link>
              <b-btn
                class="m-1 float-md-right"
                @click="_trocaSenha()"
                variant="success"
              >
                <b-icon-file-earmark-check></b-icon-file-earmark-check>
                Confirmar
              </b-btn>
            </b-col>
          </b-row>
        </template>
      </b-card>
    </b-col>
  </b-container>
</template>
<script>
/* eslint-disable no-unused-vars */
import Menu from "../shared/Menu";
export default {
  data() {
    return {
      senha: "",
      senha_confirmar: "",
      hidePassword: true,
      hidePassword_conf: true,
    };
  },
  components: {
    "meu-menu": Menu,
  },
  computed: {
    user: function () {
      return this.$store.getters.getUser;
    },
    token: function () {
      return this.$store.getters.getToken;
    },
    passwordType() {
      return this.hidePassword ? "password" : "text";
    },
    passwordIcon() {
      return this.hidePassword ? "eye-fill" : "eye-slash-fill";
    },
    passwordType_conf() {
      return this.hidePassword_conf ? "password" : "text";
    },
    passwordIcon_conf() {
      return this.hidePassword_conf ? "eye-fill" : "eye-slash-fill";
    },
  },
  methods: {
    _trocaSenha() {
      let self = this;
      if (
        this.senha === "" ||
        this.senha == null ||
        this.senha.length < 6 ||
        this.senha_confirmar === "" ||
        this.senha_confirmar == null ||
        this.senha_confirmar.length < 6 ||
        this.senha != this.senha_confirmar
      ) {
        return this.$swal({
          icon: "error",
          position: "top",
          title: "Oops...",
          text: "Não foi possivel alterar a sua senha!",
          footer:
            "Verifique os dados informados, a senha não pode ser vazia e os valores devem ser iguais - com no mínimo 4 caracteres",
        });
      }
      this.$store.dispatch("trocaSenha", this.senha).then(function (obj) {
        self
          .$swal({
            icon: "info",
            position: "top",
            title: "Senha Alterada!!",
            text: "Voce será redirecionado para a tela de login!!",
            footer: "<b>utilize a nova senha para acessar</b>",
          })
          .then((result) => {
            self.$store.dispatch("setSair");
            self.$router.push({
              name: "curriculo_main",
            });
          });
      });
    },
  },
};
</script>
<style scoped>
</style>
